import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { SubconfigurationItemLabel } from "./SubconfigurationItemLabel";
/**
 * Tab control on configuration level
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationTabsNavigation(props) {
    const { items, activePath, setActivePath: setActiveItem, navigationStyle, } = props;
    return (_jsx(Suspense, { children: _jsx(Tabs, { orientation: props.orientation, onChange: (event, newValue) => setActiveItem(newValue), value: activePath, sx: navigationStyle, children: items.map((item) => (_jsx(Tab, { value: item.path, label: _jsx(SubconfigurationItemLabel, { item: item, showCompleteIndicator: props.showCompletenessIndicator, textMode: props.textMode }) }, item.path))) }) }));
}
//# sourceMappingURL=SubconfigurationTabsNavigation.js.map